const data = {
    player: 0,
    banker: 0,
    tie: 0,
    playerPair: 0,
    bankerPair: 0,
    perfectPair: 0,
    eitherPair: 0
}

module.exports = data